<script setup lang="ts">
import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  route: null,
  isLast: { type: Boolean }
});
defineEmits(["update:route", "update:isLast"]);
import type { Router } from 'vue-router'

const { route } = __MACROS_useVModel("route", "isLast")

const router: Router | undefined = inject('default-router')

const routePath = computed(() => {
  if (!route.value.startsWith('#'))
    return '#'

  try {
    if (!router)
      return '#'
    const routeLocation = router.resolve({ name: route.value.split('#')[1] })
    return routeLocation.fullPath
  }
  catch (error) {
    return '#'
  }
})

const routeName = computed(() => {
  if (!route.value.startsWith('#'))
    return route.value

  try {
    if (!router)
      return 'FEHLER'
    const routeLocation = router.resolve({ name: route.value.split('#')[1] })
    return routeLocation.name
    // return routeLocation.meta.name
  }
  catch (error) {
    return 'FEHLER'
  }
})
</script>

<template>
  <div class="flex items-center">
    <div class="h-6 w-6 text-gray-400" i-mdi-chevron-right />
    <router-link v-if="!isLast" class="hover:text-primary-600 ml-1 text-gray-700 md:ml-2 dark:text-gray-300 dark:hover:text-white" :to="routePath">
      {{ routeName }}
    </router-link>
    <span v-else class="ml-1 text-gray-400 md:ml-2 dark:text-gray-500" aria-current="page">{{ routeName }}</span>
  </div>
</template>
